import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IBannerData } from '../../../typings/api';

export enum EBannersActionTypes {
  SetBanners = 'BANNERS/SET',
}

export type TSetBanners = ITypedReduxAction<EBannersActionTypes.SetBanners, IBannerData[]>;

export const setBanners: (banners: IBannerData[]) => TSetBanners = actionGenerator<
  EBannersActionTypes.SetBanners,
  IBannerData[]
>(EBannersActionTypes.SetBanners);
